import { useState } from "react";
import { DashboardStorePanelFilterSectionExport } from "./DashboardStorePanelFilterSectionExport";
import CheckBox from "./CheckBox";
import ButtonIconH from "./ButtonIconH";
import InputData from "./InputData";
import "../css/ReportPopup.css";

export function AdvancedOptometryReportPopup({
  type,
  createPopupQuestion,
  removePopupQuestion,
  onExport,
  onClose,
}) {
  const [options, setOptions] = useState({
    anamnesis: type === "anamnesis",
    anamnesisNotes: false,
    refractive: type === "refractive",
    refractiveNotes: false,
    oculomotor: type === "oculomotor",
    oculomotorNotes: false,
    binocular: type === "binocular",
    binocularNotes: false,
    accommodative: type === "accommodative",
    accommodativeNotes: false,
    sensory: type === "sensory",
    sensoryNotes: false,
    eyeHealth: type === "eyeHealth",
    eyeHealthNotes: false,
    email: "",
  });
  const [errorEmail, setErrorEmail] = useState(false);

  const sectionFields = [
    "anamnesis",
    "refractive",
    "oculomotor",
    "binocular",
    "accommodative",
    "sensory",
    "eyeHealth",
  ];
  const notesFields = [
    "anamnesisNotes",
    "refractiveNotes",
    "oculomotorNotes",
    "binocularNotes",
    "accommodativeNotes",
    "sensoryNotes",
    "eyeHealthNotes",
  ];

  const allSections = sectionFields.every((f) => options[f]);
  const allNotes = notesFields.every((f) => options[f]);

  const toggleAllSections = () => {
    const value = !allSections;
    setOptions((prev) => ({
      ...prev,
      ...Object.fromEntries(sectionFields.map((f) => [f, value])),
      ...(!value ? Object.fromEntries(notesFields.map((f) => [f, false])) : {}),
    }));
  };

  const toggleAllNotes = () => {
    const value = !allNotes;
    setOptions((prev) => ({
      ...prev,
      ...(value ? Object.fromEntries(sectionFields.map((f) => [f, true])) : {}),
      ...Object.fromEntries(notesFields.map((f) => [f, value])),
    }));
  };

  const checkEmail = () => {
    if (errorEmail || options.email === "") {
      createPopupQuestion(
        "Por favor, introduzca un email correcto.",
        () => {
          setErrorEmail(false);
          removePopupQuestion();
          return;
        },
        null,
        "Entendido",
      );
    }
  };

  return (
    <div className="popup-container" style={{ zIndex: 11 }}>
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">
            Informe de optometría avanzada
          </span>
          <button className="popup-action-icon close-icon" onClick={onClose}>
            <img src="/images/close-white.svg" loading="lazy" alt="Icon" />
          </button>
        </div>
        <div
          className="tab-content ap-content"
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div
            className="container-panel"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 20,
              width: 310,
            }}
          >
            <div
              className="opt-table-content grid-5"
              id="advanced-optometry-report-grid"
            >
              <div className="cell cell-label cell-start-content">
                <button
                  className="cell-label"
                  onClick={toggleAllSections}
                  tabIndex={-1}
                >
                  Categorías
                </button>
              </div>
              <div className="cell">
                <CheckBox active={allSections} onClick={toggleAllSections} />
              </div>
              <div className="cell"></div>
              <div className="cell cell-label cell-start-content">
                <button
                  className="cell-label"
                  onClick={toggleAllNotes}
                  tabIndex={-1}
                >
                  Notas
                </button>
              </div>
              <div className="cell cell-start-content">
                <CheckBox active={allNotes} onClick={toggleAllNotes} />
              </div>
              <div className="cell cell-start-content">Anamnesis</div>
              <div className="cell">
                <CheckBox
                  active={options.anamnesis}
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      anamnesis: !prev.anamnesis,
                      anamnesisNotes: prev.anamnesis
                        ? false
                        : prev.anamnesisNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">Notas</div>
              <div className="cell cell-start-content">
                <CheckBox
                  active={options.anamnesis && options.anamnesisNotes}
                  onClick={() => {
                    if (!options.anamnesis) return;
                    setOptions((prev) => ({
                      ...prev,
                      anamnesisNotes: !prev.anamnesisNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell cell-start-content">Refractivo</div>
              <div className="cell">
                <CheckBox
                  active={options.refractive}
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      refractive: !prev.refractive,
                      refractiveNotes: prev.refractive
                        ? false
                        : prev.refractiveNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">Notas</div>
              <div className="cell cell-start-content">
                <CheckBox
                  active={options.refractive && options.refractiveNotes}
                  onClick={() => {
                    if (!options.refractive) return;
                    setOptions((prev) => ({
                      ...prev,
                      refractiveNotes: !prev.refractiveNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell cell-start-content">Oculomotor</div>
              <div className="cell">
                <CheckBox
                  active={options.oculomotor}
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      oculomotor: !prev.oculomotor,
                      oculomotorNotes: prev.oculomotor
                        ? false
                        : prev.oculomotorNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">Notas</div>
              <div className="cell cell-start-content">
                <CheckBox
                  active={options.oculomotor && options.oculomotorNotes}
                  onClick={() => {
                    if (!options.oculomotor) return;
                    setOptions((prev) => ({
                      ...prev,
                      oculomotorNotes: !prev.oculomotorNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell cell-start-content">Binocular</div>
              <div className="cell">
                <CheckBox
                  active={options.binocular}
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      binocular: !prev.binocular,
                      binocularNotes: prev.binocular
                        ? false
                        : prev.binocularNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">Notas</div>
              <div className="cell cell-start-content">
                <CheckBox
                  active={options.binocular && options.binocularNotes}
                  onClick={() => {
                    if (!options.binocular) return;
                    setOptions((prev) => ({
                      ...prev,
                      binocularNotes: !prev.binocularNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell cell-start-content">Acomodativo</div>
              <div className="cell">
                <CheckBox
                  active={options.accommodative}
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      accommodative: !prev.accommodative,
                      accommodativeNotes: prev.accommodative
                        ? false
                        : prev.accommodativeNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">Notas</div>
              <div className="cell cell-start-content">
                <CheckBox
                  active={options.accommodative && options.accommodativeNotes}
                  onClick={() => {
                    if (!options.accommodative) return;
                    setOptions((prev) => ({
                      ...prev,
                      accommodativeNotes: !prev.accommodativeNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell cell-start-content">Sensorial</div>
              <div className="cell">
                <CheckBox
                  active={options.sensory}
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      sensory: !prev.sensory,
                      sensoryNotes: prev.sensory ? false : prev.sensoryNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">Notas</div>
              <div className="cell cell-start-content">
                <CheckBox
                  active={options.sensory && options.sensoryNotes}
                  onClick={() => {
                    if (!options.sensory) return;
                    setOptions((prev) => ({
                      ...prev,
                      sensoryNotes: !prev.sensoryNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell cell-start-content">Salud ocular</div>
              <div className="cell">
                <CheckBox
                  active={options.eyeHealth}
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      eyeHealth: !prev.eyeHealth,
                      eyeHealthNotes: prev.eyeHealth
                        ? false
                        : prev.eyeHealthNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">Notas</div>
              <div className="cell cell-start-content">
                <CheckBox
                  active={options.eyeHealth && options.eyeHealthNotes}
                  onClick={() => {
                    if (!options.eyeHealth) return;
                    setOptions((prev) => ({
                      ...prev,
                      eyeHealthNotes: !prev.eyeHealthNotes,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell cell-start-content combined-cells-5">
                <div className="data-field" style={{ width: "100%" }}>
                  <span>Email</span>
                  <InputData
                    type="type-email"
                    size={0}
                    input={options.email}
                    onChange={(e) => {
                      setOptions((prev) => ({
                        ...prev,
                        email: e,
                      }));
                    }}
                    onMalformed={() => setErrorEmail(true)}
                    error={errorEmail}
                  ></InputData>
                </div>
              </div>
            </div>
            <div className="popup-buttons" style={{ justifyContent: "center" }}>
              <ButtonIconH
                text="Enviar email"
                onClick={() => {
                  onExport(options);
                }}
              ></ButtonIconH>
              <ButtonIconH
                text="Exportar PDF"
                onClick={() => {
                  onExport(options);
                }}
              ></ButtonIconH>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
